import {app, db} from '../firebase';
import {doc, getDoc} from 'firebase/firestore';
import {getFunctions, httpsCallable} from 'firebase/functions';
const functions = getFunctions(app, 'asia-south1');
let checkoutPromise = null;
function loadCheckout() {
  if (window.Razorpay) return Promise.resolve(true);
  if (checkoutPromise) return checkoutPromise;
  checkoutPromise = new Promise((resolve, reject) => {
    const old = document.querySelector('script[src="https://checkout.razorpay.com/v1/checkout.js"]');
    if (old) old.remove();
    const script = document.createElement('script');
    const fail = () => {clearTimeout(timeout); script.remove(); checkoutPromise = null; reject(new Error('Payment window load failed. Same booking retry karein.'));};
    const timeout = setTimeout(fail, 20000);
    script.src = 'https://checkout.razorpay.com/v1/checkout.js'; script.async = true;
    script.onload = () => {clearTimeout(timeout); if (window.Razorpay) resolve(true); else fail();};
    script.onerror = fail; document.body.appendChild(script);
  });
  return checkoutPromise;
}
export function createBookingPaymentClient(userData = {}, selectedHotel = {}, selectedPlan = {}) {
  const loadRazorpayCheckout = loadCheckout;

  const getRazorpayContact = () => {
    const digits = String(
      userData?.phoneNumber || ""
    ).replace(/\D/g, "");

    if (digits.length === 10) {
      return `+91${digits}`;
    }

    return digits;
  };

  const startRazorpayPayment =
    async ({
      bookingId,
      checkInCode,
      amount,
    }) => {
      const stored = await getDoc(doc(db, 'bookings', bookingId));
      if (stored.exists() && stored.data().paid && stored.data().paymentVerified) return {paid: true, verification: {ok: true, amountPaid: stored.data().paidAmount}};
      await loadRazorpayCheckout();

      const createOrder =
        httpsCallable(
          functions,
          "createRazorpayOrder"
        );

      const verifyPayment =
        httpsCallable(
          functions,
          "verifyRazorpayPayment"
        );

      const orderResponse =
        await createOrder({
          bookingId,
        });

      const order =
        orderResponse?.data || {};

      if (
        !order?.orderId ||
        !order?.keyId ||
        !Number(order?.amount)
      ) {
        throw new Error(
          "Razorpay order create nahi hua."
        );
      }

      return new Promise(
        (resolve, reject) => {
          let completed = false;
          let verifying = false;

          const finishOnce = (
            callback
          ) => {
            if (completed) return;

            completed = true;
            callback();
          };

          const razorpay =
            new window.Razorpay({
              key:
                order.keyId,

              amount:
                Number(
                  order.amount
                ),

              currency:
                order.currency ||
                "INR",

              name:
                "Hotel Dev Palace",

              description:
                `${
                  selectedHotel?.name ||
                  "Hotel Booking"
                } • ${
                  selectedPlan?.title ||
                  "Stay"
                }`,

              order_id:
                order.orderId,

              prefill: {
                name:
                  userData?.name ||
                  "",

                email:
                  userData?.email ||
                  "",

                contact:
                  getRazorpayContact(),
              },

              notes: {
                bookingId:
                  bookingId,

                hotel:
                  selectedHotel?.name ||
                  "",

                checkInCode:
                  checkInCode ||
                  "",
              },

              theme: {
                color:
                  "#2563eb",
              },

              handler:
                async (
                  paymentResponse
                ) => {
                  verifying = true;
                  try {
                    const verifyResponse =
                      await verifyPayment(
                        {
                          bookingId,

                          razorpay_payment_id:
                            paymentResponse
                              ?.razorpay_payment_id,

                          razorpay_order_id:
                            paymentResponse
                              ?.razorpay_order_id,

                          razorpay_signature:
                            paymentResponse
                              ?.razorpay_signature,
                        }
                      );

                    const verified =
                      verifyResponse?.data;

                    if (
                      !verified?.ok
                    ) {
                      throw new Error(
                        "Payment verify nahi hui."
                      );
                    }

                    finishOnce(() =>
                      resolve({
                        paid: true,

                        verification:
                          verified,

                        paymentId:
                          paymentResponse
                            ?.razorpay_payment_id ||
                          "",
                      })
                    );
                  } catch (
                    error
                  ) {
                    console.error(
                      "Razorpay verify error:",
                      error
                    );

                    finishOnce(() =>
                      reject(
                        new Error(
                          error?.message ||
                            "Payment verification failed."
                        )
                      )
                    );
                  }
                },

              modal: {
                ondismiss: () => {
                  if (verifying) return;
                  finishOnce(() =>
                    resolve({
                      paid: false,
                      dismissed:
                        true,
                    })
                  );
                },

                escape: true,
              },
            });

          razorpay.on(
            "payment.failed",
            (response) => {
              console.error(
                "Razorpay payment failed:",
                response?.error ||
                  response
              );

              // Razorpay may permit another attempt inside the same window. Settle only on success/dismiss.

            }
          );

          razorpay.open();
        }
      );
    };


  return startRazorpayPayment;
}
